import { call, put, takeLatest } from 'redux-saga/effects';

import { failAction, setLabs } from './labs.redux';
import { getLabs } from './labs.redux';
import { ILab } from 'shared/interfaces/lab.interface';
import LabService from 'shared/services/LabService';

function* getLabsSaga() {
  try {
    const result: ILab[] = yield call(LabService.getLabs);
    yield put(setLabs(result));
  } catch (error) {
    console.log('error', error);
    yield put(failAction());
  }
}

function* Labs() {
  yield takeLatest(getLabs.type, getLabsSaga);
}

export default Labs;
